import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const MegaphoneIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.06887 4.70754L10.538 1.88448C10.8439 1.78251 11.1643 1.73053 11.4867 1.73053H11.4999C13.4329 1.73053 14.9999 3.96911 14.9999 6.73053C14.9999 9.49195 13.4329 11.7305 11.4999 11.7305H11.3292C11.1103 11.7305 10.8921 11.7065 10.6784 11.6591L2.0864 9.74975C2.02999 9.73722 1.97854 9.70829 1.93852 9.6666C0.631815 8.30539 0.642601 6.14443 1.9493 4.78323C1.98238 4.74877 2.02356 4.72264 2.06887 4.70754ZM11.5 10.2305C12.6046 10.2305 13.5 8.66353 13.5 6.73053C13.5 4.79753 12.6046 3.23053 11.5 3.23053C10.3954 3.23053 9.5 4.79753 9.5 6.73053C9.5 8.66353 10.3954 10.2305 11.5 10.2305Z"
		/>
		<path
			fill="currentColor"
			d="M3 11.2305L3.82598 14.9474C3.92766 15.405 4.33347 15.7305 4.80217 15.7305H5C5.55228 15.7305 6 15.2828 6 14.7305V11.7305L3 11.2305Z"
		/>
		<path
			fill="currentColor"
			d="M12.25 6.73053C12.25 7.42089 11.9142 7.98053 11.5 7.98053C11.0858 7.98053 10.75 7.42089 10.75 6.73053C10.75 6.04017 11.0858 5.48053 11.5 5.48053C11.9142 5.48053 12.25 6.04017 12.25 6.73053Z"
		/>
	</svg>
))
